export class PrintSerialsRequest {
    printerId: string;
    serials: number[];

    constructor(printerId: string, serials: number[]) {
        this.printerId = printerId;
        this.serials = serials;
    }
}
